import { Project } from "../api";
import {IngestionMessage, MessageScope} from "../asset-service-api";
import { getMappedTrack } from "../Behaviors/projects";
import { getMappedResources } from "../Behaviors/projectTools";

const getSampleRateBitDepthInconsistentErrors = (project: Project) : IngestionMessage[] =>
{
    if (!project) return [];

    const mappedResources = getMappedResources(project);

    mappedResources.sort((a, b) => getMappedTrack(project, a)!.number - getMappedTrack(project, b)!.number);

    const firstResource = mappedResources[0];
    const mismatched = mappedResources.filter(t => t.audioInfo?.bit_depth !== firstResource.audioInfo?.bit_depth || t.audioInfo?.sample_rate !== firstResource.audioInfo?.sample_rate);
    return mismatched.map(track => {
        return {
            details: "Assigned asset files have inconsistent bit depths.",
            message: `Sample Rate x Bit Depth (${track.audioInfo?.sample_rate} x ${track.audioInfo?.bit_depth}) does not match Track ${getMappedTrack(project, firstResource)?.number} (${firstResource.audioInfo?.sample_rate} x ${firstResource.audioInfo?.bit_depth}).`,
            messageType: "Error",
            source: {
                scope: MessageScope.Track,
                stage: "local",
                target: getMappedTrack(project, track)?.number.toString(),
                id: "8372DDD4-FFB3-40C3-A6B8-4CCF7DBC88F3",
            },
        } as IngestionMessage;
    }).sort((a, b) => Number(a.source?.target) - Number(b.source?.target));
};

export { getSampleRateBitDepthInconsistentErrors};
